import { ApiOptions } from '../../api-options.decorator';
import { ParamsAdapter } from '../../params.adapter';

import { ApiBaseCore } from './base';

export class ApiCoreCost extends ApiBaseCore {
  @ApiOptions({ channel: 'costTaxListGasGet' })
  getGasTaxList(params: ParamsAdapter) {
    return this.get(`/cost/ngfr/tax`, params);
  }

  @ApiOptions({ channel: 'costTaxListPowerGet' })
  getPowerTaxList(params: ParamsAdapter) {
    return this.get(`/cost/pwfr/tax`, params);
  }

  @ApiOptions({ interceptErrors: false })
  getCountryVat(country: string, vatType: string, params: ParamsAdapter) {
    return this.get(`/cost/vat/${country}/${vatType}`, params);
  }
}
